export default function LibraryResultBanner({
  count,
  queryLabel,
  actionLabel,
  onAction,
}) {
  return (
    <div className="clear-search">
      <div className="clear-search-card">
        <p className="clear-search-kicker">{count} results for</p>
        <p className="clear-search-query">{queryLabel}</p>
        <button
          type="button"
          className="clear-search-action"
          onClick={onAction}
        >
          {actionLabel}
        </button>
      </div>
    </div>
  );
}
